import { format } from 'date-fns';

/** User-facing date and time, matching events pages (e.g. "May 24, 2026 at 3:30 PM"). */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return `${format(date, 'PPP')} at ${format(date, 'p')}`;
}

/** Value for `<input type="datetime-local" />` from an ISO string. */
export function toDatetimeLocalValue(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
